export const TiktokBrowser = () => {
    return (
        <div id="open-browser-tip">
            <style>
                {`
                    #open-browser-tip {
                        position: fixed;
                        top: 10px;
                        right: 15px;
                        display: flex;
                        z-index: 9999;
                        flex-direction: column;
                        align-items: flex-end;
                        gap: 10px;
                        pointer-events: none;
                    }
                    .finger {
                        font-size: 32px;
                        animation: bounce 1.2s infinite ease-in-out;
                        transform-origin: center;
                    }
                    @keyframes bounce {
                        0%, 100% { transform: translateY(0) rotate(45deg); }
                        50% { transform: translateY(-10px) rotate(0deg); }
                    }
                    @keyframes fadeIn {
                        from { opacity: 0; transform: translateY(-20px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                `}
            </style>
            <div className="finger">☝</div>
            <div>
                <div>1. Нажми на три точки <strong>•••</strong></div>
                <br/>
                <div>2. Выбери <strong>«Открыть в браузере»</strong></div>
            </div>
        </div>
    )
}
